// chatbotReducer.js
  import { TOGGLE_CHATBOT, SHOW_CHATBOT, HIDE_CHATBOT } from '../actions/chatbotActions';

const initialState = {
  visible: false,
  loading: false,
  error: null,
  messages: [],
  chats: [],
  activeChatId: null,
};

const chatbotReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_CHATBOT:
      return { ...state, visible: !state.visible };

    case SHOW_CHATBOT:
      return { ...state, visible: true };

    case HIDE_CHATBOT:
      return { ...state, visible: false };

    case 'CHATBOT_MESSAGE_SEND_START':
      return { ...state, loading: true, error: null };

    case 'CHATBOT_MESSAGE_SEND_SUCCESS':
      return {
        ...state,
        loading: false,
      };

    case 'CHATBOT_MESSAGE_SEND_FAILURE':
      return { ...state, loading: false, error: action.payload };


    case 'RESET_ACTIVE_CHAT':
      return { ...state, activeChatId: null };

    case 'SET_ACTIVE_CHAT':
      return { ...state, activeChatId: action.payload };

    case 'CHATBOT_MESSAGE_PARTIAL':
      return {
        ...state,
        messages: state.messages.map((m, i, arr) =>
          i === arr.length - 1 && m.type === 'bot'
            ? { ...m, text: (m.text || '') + action.payload }
            : m
        ),
      };

    case "CHATBOT_CLEAR_MESSAGES":
      return {
        ...state,
        messages: [],
      };


    case "CHATBOT_SET_CHATS":
      return {
        ...state,
        chats: action.payload || [],
      };

    case "CHATBOT_SET_MESSAGES":
      return {
        ...state,
        messages: action.payload || [],
      };

    case "CHATBOT_DELETE_CHAT":
      return {
        ...state,
        chats: state.chats.filter(
          (chat) => chat.chat_id !== action.payload
        ),
        messages: [],
      };


    case "CHATBOT_ADD_CHAT":
      return {
        ...state,
        chats: [
          action.payload,
          ...(state.chats || []),
        ],
      };
      
    case "CHATBOT_RENAME_CHAT":
      return {
        ...state,
        chats: state.chats.map((chat) =>
          chat.chat_id === action.payload.chat_id
            ? { ...chat, title: action.payload.title }
            : chat
        ),
      };
    case 'CHATBOT_MESSAGE_SEND_START_BOT':
      return {
        ...state,
        messages: [
          ...state.messages,
          {
            type: 'bot',
            text: '',
            sender: 'bot',
            senderName: 'Rabo',
            time: new Date().toLocaleTimeString([], {
              hour: 'numeric',
              minute: '2-digit',
            }),
          },
        ],
      };

    case 'CHATBOT_MESSAGE_SEND_USER':
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };

    default:
      return state;
  }
};

export default chatbotReducer;